export {
  default,
  type MenuTriggerProps,
  type MenuTriggerComponentProps,
  type MenuTriggerDefaultExport,
} from './MenuTrigger';
